<template>
    <div class="goods_index">
        <div class="shop_top"><shop-top  :subnav_show="false" :change_color="true"></shop-top></div>

<div class="special">
<div style="height: 50px;"></div>
<div class="banner"></div>
<div style="height: 1000px;"></div>
<!--应季热销-->
<div class="banner1" id="title"><a href="/event/gather" target="_blank"></a></div>
<div class="banner2" id="title1"><a href="/special/list/MjAyMDA5MjdfMTA=" target="_blank"></a></div><!--保健品-->
<div class="banner3" id="title2"><a href="/special/list/MjAyMDA5MjdfOA==" target="_blank"></a></div><!--中药饮片-->
<div class="banner4" id="title3"><a href="/special/list/MjAyMDA5MjdfOQ==" target="_blank"></a></div>
<!--医疗器械-->
<!-- <div class="banner5" id="title4"><a href="/goods/params/?keyword=%E5%A6%86" target="_blank"></a></div> -->
<div style="height: 50px;"></div>
</div>

        <!-- <div class="empty_order">
            <dl>
                <p style="text-align:center"><img src="/pc/not-common2-icon.png" alt=""></p>
                <p style="text-align:center; margin-top:30px;">暂无活动~</p>
                <p style="color:#fff; text-align:center; margin-top:30px;"><router-link to="/"><el-button type="primary">前往商城</el-button></router-link></p>
            </dl>
        </div> -->



        <shop-foot></shop-foot>
        <!-- vue 回到顶部 -->
        <ShopMbar></ShopMbar>
        
    </div>
</template>

<script>
import ShopTop from "@/components/home/public/head.vue"
import ShopFoot from "@/components/home/public/shop_foot.vue"
import ShopMbar from "@/components/home/public/mui_mbar_tabs.vue"

import {formatDate} from '@/utils/date';

export default {
    components: {
        ShopTop,
        ShopFoot,
        ShopMbar,
    },
    props: {},
    data() {
      return {
          list:[],
          props:{
              value:'id',
              label:'name',
              checkStrictly:true,
          },
          info:{
          },
            pageSize:20,
            pageNum:1,
            
      };
    },
    watch: {
        
    },
    computed: {
        
    },
    filters: {
      formatDate(time) {
        if (time == null || time === '') {
          return '';
        }
        let date = new Date(time);
        return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
      },
      formatTime(time){
        if(time==null||time===''){
          return '';
        }
        let date = new Date(time);
        return formatDate(date, 'yyyy-MM-dd')
      },
    },
    methods: {
        // 商品列表
        // getList:function(){ 
        //     //this.$get(this.$api.getSpecialGoodsById,this.info).then(res=>{
        //      this.$get(this.$api.getSpecialGoodsById,{subjectId:this.specialid,pageSize:this.pageSize,pageNum:this.pageNum}).then(res=>{
        //         this.list = res.data.list[0].indexGoodsParamList;
        //         this.total = res.data.list[0].count;
        //         document.title = res.data.list[0].title;
        //         this.header = res.data.list;
        //         // this.specialid = this.$route.params.info;
        //         this.pageNum = res.data.list[0].pageNum;
        //         //this.pageSize = res.data.pageSize;
        //         //this.totalPage = res.data.list[0].totalPage;
        //         //this.total = res.data.list.total;

        //     });
        // },
        
        //附件路径
        filepath:function(){ 
             this.$get(this.$api.filepath,{platId:this.$platId}).then(res=>{
                this.filePath = res.data[0].config;
            });
        },

        // 分页改变
        // current_change:function(e){
        //     this.pageNum = e;
        //     this.getList();
        // },

    },
    created() {
        // this.specialid = this.$route.params.info;
        // //document.title = this.header.title;
        // if(this.$isEmpty(this.specialid)){
        //     return this.$message.error('请检查专题是否存在');
        // }
        // this.getList();
        this.filepath();
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
.goods_index{
    background: #fff;
}
.goods_sort_top{
    position: relative;
    color:#666;
    i{
        position: absolute;
        right: -16px;
        font-size: 12px;
    }
}
.goods_sort_bottom{
    
    position: relative;
    color:#666;
    i{
        position: absolute;
        right: -16px;
        font-size: 12px;
    }
}
.mbx{
    margin:20px auto;
}
.goods_where{
    border:1px solid #efefef;
    background: #fff;
    line-height: 50px;
    font-size: 14px;
    .goods_cat_list,.home_goods_cat_list{
        border-bottom: 1px solid #efefef;
        padding-left:20px; 
        height: 50px;
        line-height: 50px;
        .goods_cat_title{
            float: left;
            margin-right: 20px;
            height: 50px;
            line-height: 50px;
        }
        ul{
            float: left;
        }
        ul.goods_sort_ul{
            li{
                margin-right: 30px;
            }
        }
        ul li{
            float: left;
            color:#666;
            margin-right: 20px;
            a{
                color:#666;
            }
            a:hover{
                color:#F56C6C;
            }
        }
        li:hover{
            color:#F56C6C;
        }
        ul li.font_color{
            color:#F56C6C;
        }
        
    }
    .goods_cat_list:after{
        content:'';
        clear:both;
        display: block;
    }
    .goods_cat_list:last-child{
        border-bottom: none;
    }
}
.goods_list{
    margin:40px auto;
    .goods_list_item{
        float: left;
        width: 224px;
        height: 420px;
        box-sizing: border-box;
        margin: 0 20px 20px 0;
        background: #fff;
        dl{
            border: 1px solid #efefef;
            box-sizing: border-box;
            width: 224px;
            height: 420px;
            -webkit-transition: all .2s linear;
            transition: all .2s linear;
            .el-image{
                width: 180px;
                height: 180px;
                margin:25px auto 25px auto;
                display: block;
            }
        }
        dl dt img{
            width: 180px;
            height: 180px;
            margin:30px auto 25px auto;
            display: block;
        }
        dl dd{
            font-size: 14px;
            padding: 0 15px;
            width: 192px;
            line-height: 25px;
        }
        dl .parameter{
            font-size: 12px;
            color:#666666;
        }
        dl dd.title{
            color: #000;
            height: 30px;
            line-height: 30px;
            // text-align: center;
            overflow: hidden;
        }
        dl dd.price {
            color: #e01d20;
            line-height: 40px;
            text-align: left;
            font-size: 16px;
            overflow: hidden;
            font-weight: bold;
        }
        dl dd.price span{
            font-size: 14px;
            color: #b0b0b0;
            margin-left: 8px;
            text-decoration: line-through;
            font-weight: normal;
            line-height: 40px;
            float:right;
        }
        dl dd span:last-child{
            text-align: right;
        }
        // dl dd span:first-child:hover{
        //     color:#fff;
        //     background: #F56C6C;
        // }
        dl dd span{
            width: 50%;
            display: block;
            // border-top: 1px solid #efefef;
            float: left;
            line-height: 25px;
            height: 25px;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: left;
        }
    }
    .goods_list_item:nth-child(5n){
        margin-right: 0;
    }
    // .goods_list_item:hover{
    //     // border:1px solid #F56C6C;
    // }
    .goods_list_item:hover dl{
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        margin-top:-3px;
    }
}
</style>

<style>
/* 
body,ul,div,li,img,span{ padding:0; margin:0;}
a,a:hover,a:visited{text-decoration:none;} */
li{ list-style:none;}
.special{background:url(https://www.sckxyy.com/imgs/imgs/subject/bg.jpg) #03081e center top no-repeat;}
.banner{ height:auto; width: 1280px; margin: 0 auto; margin-bottom: 20px;}
	
.banner1{background:url(https://www.sckxyy.com/imgs/imgs/sckxyy/special/title1.png) no-repeat center 0px; background-size: 90% 90%; width: 1287px; height:743px; margin: 0 auto; margin-bottom: 40px;}
.banner1 a{ width: 1287px; height:743px; display: block;}

.banner2{background:url(https://www.sckxyy.com/imgs/imgs/sckxyy/special/title2.png) no-repeat center 0px;background-size: 90% 90%; width: 1287px; height:737px; margin: 0 auto;  margin-bottom: 40px;}
.banner2 a{width: 1287px; height:737px; display: block;}

.banner3{background:url(https://www.sckxyy.com/imgs/imgs/sckxyy/special/title3.png) no-repeat center 0px;background-size: 90% 90%; width: 1287px; height:737px; margin: 0 auto;  margin-bottom: 40px;}
.banner3 a{ width: 1287px; height:737px; display: block;}
	
.banner4{background:url(https://www.sckxyy.com/imgs/imgs/sckxyy/special/title4.png) no-repeat center 0px;background-size: 90% 90%; width: 1287px; height:737px;  margin: 0 auto;  margin-bottom: 40px;}
.banner4 a{width: 1287px; height:737px;  margin: 0 auto; display: block;}

.banner5{background:url(https://www.sckxyy.com/imgs/imgs/sckxyy/special/title5.png) no-repeat center 0px;background-size: 90% 90%; width: 1228px; height:766px;  margin: 0 auto;   margin-bottom: 50px;}
.banner5 a{width: 1228px; height:766px;  display: block;}

/* .banner6{background:url(/public/pc/special/title6.png) no-repeat center; width: 1200px; height:814px;  margin: 0 auto; }
.banner6 a{width: 1200px; height:814px;  display: block;} */


.reduction-bottom{  width:100%; overflow:hidden;}
.special-zone{ width:1200px; margin:auto;overflow:hidden; padding-top:30px; padding-bottom:190px; font-family:"黑体";}
</style>